
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("gSSyD", function(module, exports) {
module.exports = JSON.parse("{}");

});


//# sourceMappingURL=pt-BR.54441401.js.map
